import i18next from 'i18next'
import HttpBackend from 'i18next-http-backend'
import ChainedBackend from 'i18next-chained-backend'
import resourcesToBackend from 'i18next-resources-to-backend'

let debugMode = false

/**
 * vueI18next plugin
 * @type {{install: vueI18next.install}}
 */
export const vueI18next = {
  install: (vue) => {
    vue.config.globalProperties.$t = $t
  },
}

/**
 * Change language (load phrases from api)
 * @param lang
 * @returns {Promise<void>}
 * @constructor
 */
export async function initTranslator(lang, ns, translations) {
  const backends = []
  const backendOptions = []
  if (translations) {
    const defaultResource = {}
    defaultResource[lang] = {}
    defaultResource[lang][ns] = translations

    backends.push(resourcesToBackend(defaultResource))
    backendOptions.push({})
  }

  backends.push(HttpBackend)
  backendOptions.push({
    loadPath: '/service/translate/list/?lang=%lng%&groupId=%ns%',
    addPath: '/service/translate/add-phrase?lang=%lng%&groupId=%ns%',
  })

  await i18next.use(ChainedBackend).init({
    lng: lang,
    fallbackLng: false,
    ns,
    debug: debugMode,
    saveMissing: true, // always for debug
    backend: {
      backends,
      backendOptions,
    },
    interpolation: {
      prefix: '%',
      suffix: '%',
    },
  })
}

/**
 * Enable or disable debug mode
 * @param mode
 */
export function setDebug(mode) {
  debugMode = mode
}

/**
 * Translate function
 * @param key
 * @param opts
 * @returns {string|*}
 */
export function $t(key, opts) {
  return i18next.t(key, opts)
}
